import dynamic from 'next/dynamic';
const Pagination = dynamic(() => import('./Pagination'));

export default Pagination;
